import config from './config';
const logger = function () {
  if (config.IS_LOGGING) {
    console.log(...arguments);
  }
};

export default logger;
